import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthContextProvider } from "./context/authContext";
import { DarkModeContextProvider } from "./context/darkModeContext";
import { setTranslations, setDefaultLanguage, withTranslation } from 'react-multi-lang'
import ua from './translate/ua/translation.json'
import en from './translate/en/translation.json'

//const globalStateContext = React.createContext(globalState);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <DarkModeContextProvider>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </DarkModeContextProvider>
);
